// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.14.0 (commit 3ac273e970212dd613e57f4c312c49a9ab8ccb50).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AddModelReducer from "./add_model_reducer";
import AddModelComponentReducer from "./add_model_component_reducer";
import AddModelPropertyReducer from "./add_model_property_reducer";
import AddModelRelationshipReducer from "./add_model_relationship_reducer";
import AddModelTelemetryReducer from "./add_model_telemetry_reducer";
import AddModelsReducer from "./add_models_reducer";
import AddModelsFromJsonReducer from "./add_models_from_json_reducer";
import AddProjectSurfaceReducer from "./add_project_surface_reducer";
import AddProjectSurfaceScopedReducer from "./add_project_surface_scoped_reducer";
import AddRelationshipReducer from "./add_relationship_reducer";
import AddRelationshipCascadeRuleReducer from "./add_relationship_cascade_rule_reducer";
import AddRelationshipsReducer from "./add_relationships_reducer";
import AddRelationshipsFromJsonReducer from "./add_relationships_from_json_reducer";
import AddTwinReducer from "./add_twin_reducer";
import AddTwinCompleteReducer from "./add_twin_complete_reducer";
import AddTwinGeometryBindingReducer from "./add_twin_geometry_binding_reducer";
import AddTwinWithMetadataReducer from "./add_twin_with_metadata_reducer";
import AddTwinsReducer from "./add_twins_reducer";
import AddTwinsCompleteReducer from "./add_twins_complete_reducer";
import AddTwinsFromJsonReducer from "./add_twins_from_json_reducer";
import AddTwinsWithMetadataReducer from "./add_twins_with_metadata_reducer";
import CleanupOrphanedPropertyValuesReducer from "./cleanup_orphaned_property_values_reducer";
import ClearAllDataReducer from "./clear_all_data_reducer";
import ClearAllModelAssetLinksReducer from "./clear_all_model_asset_links_reducer";
import ClearAllTwinAssetLinksReducer from "./clear_all_twin_asset_links_reducer";
import ClearAllTwinDataReducer from "./clear_all_twin_data_reducer";
import ClearControlPointsReducer from "./clear_control_points_reducer";
import ClearModelAssetLinksReducer from "./clear_model_asset_links_reducer";
import ClearModelDofLinkReducer from "./clear_model_dof_link_reducer";
import ClearProjectLocationReducer from "./clear_project_location_reducer";
import ClearTwinAssetLinksReducer from "./clear_twin_asset_links_reducer";
import ClearTwinDofBindingReducer from "./clear_twin_dof_binding_reducer";
import ClearTwinDofLinkReducer from "./clear_twin_dof_link_reducer";
import ClearTwinDynamicLocationStreamNameReducer from "./clear_twin_dynamic_location_stream_name_reducer";
import ClearUeProjectConfigReducer from "./clear_ue_project_config_reducer";
import CreateModelVersionReducer from "./create_model_version_reducer";
import CreateTurbotwinMetadataReducer from "./create_turbotwin_metadata_reducer";
import CreateTwinTelemetryLinkReducer from "./create_twin_telemetry_link_reducer";
import DeleteAllRelationshipsForTwinReducer from "./delete_all_relationships_for_twin_reducer";
import DeleteImportTemplateReducer from "./delete_import_template_reducer";
import DeleteModelReducer from "./delete_model_reducer";
import DeleteModelCascadeReducer from "./delete_model_cascade_reducer";
import DeleteModelContentReducer from "./delete_model_content_reducer";
import DeleteModelVersionReducer from "./delete_model_version_reducer";
import DeleteRelationshipReducer from "./delete_relationship_reducer";
import DeleteRelationshipByTwinsReducer from "./delete_relationship_by_twins_reducer";
import DeleteRelationshipCascadeRuleReducer from "./delete_relationship_cascade_rule_reducer";
import DeleteSystemConfigReducer from "./delete_system_config_reducer";
import DeleteTurbotwinMetadataReducer from "./delete_turbotwin_metadata_reducer";
import DeleteTwinReducer from "./delete_twin_reducer";
import DeleteTwinPropertyReducer from "./delete_twin_property_reducer";
import DeleteTwinTelemetryLinkReducer from "./delete_twin_telemetry_link_reducer";
import DeleteTwinsReducer from "./delete_twins_reducer";
import DryRunImportDtdlGraphReducer from "./dry_run_import_dtdl_graph_reducer";
import DuplicateTwinReducer from "./duplicate_twin_reducer";
import ExportGraphReducer from "./export_graph_reducer";
import ExportModelReducer from "./export_model_reducer";
import ExportRelationshipReducer from "./export_relationship_reducer";
import ExportTwinReducer from "./export_twin_reducer";
import GetModuleInfoReducer from "./get_module_info_reducer";
import GetTelemetryLinksForComponentReducer from "./get_telemetry_links_for_component_reducer";
import ImportControlPointsReducer from "./import_control_points_reducer";
import ImportDtdlGraphFromJsonReducer from "./import_dtdl_graph_from_json_reducer";
import ImportDtdlGraphFromJsonWithStringModesReducer from "./import_dtdl_graph_from_json_with_string_modes_reducer";
import PostRestoreNormalizeReducer from "./post_restore_normalize_reducer";
import PromoteTwinToSurfaceReducer from "./promote_twin_to_surface_reducer";
import PruneEditJournalReducer from "./prune_edit_journal_reducer";
import RecordImportRunReducer from "./record_import_run_reducer";
import RegisterAdminServiceReducer from "./register_admin_service_reducer";
import RemoveModelAssetBindingReducer from "./remove_model_asset_binding_reducer";
import RemoveModelUeClassReducer from "./remove_model_ue_class_reducer";
import RemoveModuleUserReducer from "./remove_module_user_reducer";
import RemoveProjectBackgroundLayerReducer from "./remove_project_background_layer_reducer";
import RemoveProjectSurfaceReducer from "./remove_project_surface_reducer";
import RemoveTwinAssetBindingReducer from "./remove_twin_asset_binding_reducer";
import RemoveTwinGeometryBindingReducer from "./remove_twin_geometry_binding_reducer";
import RemoveTwinUeClassReducer from "./remove_twin_ue_class_reducer";
import RenameModelContentReducer from "./rename_model_content_reducer";
import ReorderProjectBackgroundLayersReducer from "./reorder_project_background_layers_reducer";
import ReorderProjectSurfacesReducer from "./reorder_project_surfaces_reducer";
import ReportImportMappingProgressReducer from "./report_import_mapping_progress_reducer";
import RequestImportMappingReducer from "./request_import_mapping_reducer";
import RestoreComplexPropertyReducer from "./restore_complex_property_reducer";
import RestoreDigitalTwinReducer from "./restore_digital_twin_reducer";
import RestoreDtdlComponentReducer from "./restore_dtdl_component_reducer";
import RestoreDtdlExtendsReducer from "./restore_dtdl_extends_reducer";
import RestoreDtdlInterfaceReducer from "./restore_dtdl_interface_reducer";
import RestoreDtdlPropertyReducer from "./restore_dtdl_property_reducer";
import RestoreDtdlRelationshipReducer from "./restore_dtdl_relationship_reducer";
import RestoreDtdlTelemetryReducer from "./restore_dtdl_telemetry_reducer";
import RestorePrimitivePropertyBoolReducer from "./restore_primitive_property_bool_reducer";
import RestorePrimitivePropertyByteReducer from "./restore_primitive_property_byte_reducer";
import RestorePrimitivePropertyBytesReducer from "./restore_primitive_property_bytes_reducer";
import RestorePrimitivePropertyDateReducer from "./restore_primitive_property_date_reducer";
import RestorePrimitivePropertyDateTimeReducer from "./restore_primitive_property_date_time_reducer";
import RestorePrimitivePropertyDecimalReducer from "./restore_primitive_property_decimal_reducer";
import RestorePrimitivePropertyDoubleReducer from "./restore_primitive_property_double_reducer";
import RestorePrimitivePropertyDurationReducer from "./restore_primitive_property_duration_reducer";
import RestorePrimitivePropertyFloatReducer from "./restore_primitive_property_float_reducer";
import RestorePrimitivePropertyIntegerReducer from "./restore_primitive_property_integer_reducer";
import RestorePrimitivePropertyLongReducer from "./restore_primitive_property_long_reducer";
import RestorePrimitivePropertyShortReducer from "./restore_primitive_property_short_reducer";
import RestorePrimitivePropertyStringReducer from "./restore_primitive_property_string_reducer";
import RestorePrimitivePropertyTimeReducer from "./restore_primitive_property_time_reducer";
import RestorePrimitivePropertyUnsignedByteReducer from "./restore_primitive_property_unsigned_byte_reducer";
import RestorePrimitivePropertyUnsignedIntegerReducer from "./restore_primitive_property_unsigned_integer_reducer";
import RestorePrimitivePropertyUnsignedLongReducer from "./restore_primitive_property_unsigned_long_reducer";
import RestorePrimitivePropertyUnsignedShortReducer from "./restore_primitive_property_unsigned_short_reducer";
import RestorePrimitivePropertyUuidReducer from "./restore_primitive_property_uuid_reducer";
import RestoreTurbotwinMetadataReducer from "./restore_turbotwin_metadata_reducer";
import RestoreTwinComponentReducer from "./restore_twin_component_reducer";
import RestoreTwinDofLinkReducer from "./restore_twin_dof_link_reducer";
import RestoreTwinPositionReducer from "./restore_twin_position_reducer";
import RestoreTwinPropertyReducer from "./restore_twin_property_reducer";
import RestoreTwinRelationshipInstanceReducer from "./restore_twin_relationship_instance_reducer";
import RestoreTwinTelemetryLinkReducer from "./restore_twin_telemetry_link_reducer";
import RetargetRelationshipReducer from "./retarget_relationship_reducer";
import SaveImportTemplateReducer from "./save_import_template_reducer";
import SetBindingEnabledReducer from "./set_binding_enabled_reducer";
import SetControlPointEnabledReducer from "./set_control_point_enabled_reducer";
import SetEditProvenanceReducer from "./set_edit_provenance_reducer";
import SetFirstTwinFallbackReducer from "./set_first_twin_fallback_reducer";
import SetModelAssetBindingReducer from "./set_model_asset_binding_reducer";
import SetModelAssetBindingScopedReducer from "./set_model_asset_binding_scoped_reducer";
import SetModelDofLinkReducer from "./set_model_dof_link_reducer";
import SetModelUeClassReducer from "./set_model_ue_class_reducer";
import SetModuleUserRoleReducer from "./set_module_user_role_reducer";
import SetProjectBackgroundLayerReducer from "./set_project_background_layer_reducer";
import SetProjectBackgroundLayerStateReducer from "./set_project_background_layer_state_reducer";
import SetProjectLocationStaticReducer from "./set_project_location_static_reducer";
import SetProjectLocationTwinReferenceReducer from "./set_project_location_twin_reference_reducer";
import SetProjectScopeReducer from "./set_project_scope_reducer";
import SetProjectSurfaceClientStateReducer from "./set_project_surface_client_state_reducer";
import SetProjectSurfaceStateReducer from "./set_project_surface_state_reducer";
import SetProjectSurfaceTwinReducer from "./set_project_surface_twin_reducer";
import SetProjectTenantConfigReducer from "./set_project_tenant_config_reducer";
import SetStartupMapReducer from "./set_startup_map_reducer";
import SetSystemConfigReducer from "./set_system_config_reducer";
import SetTwinAssetBindingReducer from "./set_twin_asset_binding_reducer";
import SetTwinAssetBindingScopedReducer from "./set_twin_asset_binding_scoped_reducer";
import SetTwinDofBindingReducer from "./set_twin_dof_binding_reducer";
import SetTwinDofLinkReducer from "./set_twin_dof_link_reducer";
import SetTwinMeshSectionReducer from "./set_twin_mesh_section_reducer";
import SetTwinUeClassReducer from "./set_twin_ue_class_reducer";
import SetUeProjectConfigReducer from "./set_ue_project_config_reducer";
import SubmitImportMappingReducer from "./submit_import_mapping_reducer";
import TransferAdminServiceReducer from "./transfer_admin_service_reducer";
import UndoEditReducer from "./undo_edit_reducer";
import UndoImportRunReducer from "./undo_import_run_reducer";
import UpdateModelReducer from "./update_model_reducer";
import UpdateModelVersionStatusReducer from "./update_model_version_status_reducer";
import UpdatePropertyBooleanReducer from "./update_property_boolean_reducer";
import UpdatePropertyByteReducer from "./update_property_byte_reducer";
import UpdatePropertyBytesReducer from "./update_property_bytes_reducer";
import UpdatePropertyComplexReducer from "./update_property_complex_reducer";
import UpdatePropertyDateReducer from "./update_property_date_reducer";
import UpdatePropertyDateTimeReducer from "./update_property_date_time_reducer";
import UpdatePropertyDecimalReducer from "./update_property_decimal_reducer";
import UpdatePropertyDoubleReducer from "./update_property_double_reducer";
import UpdatePropertyDurationReducer from "./update_property_duration_reducer";
import UpdatePropertyFloatReducer from "./update_property_float_reducer";
import UpdatePropertyIntegerReducer from "./update_property_integer_reducer";
import UpdatePropertyLongReducer from "./update_property_long_reducer";
import UpdatePropertyShortReducer from "./update_property_short_reducer";
import UpdatePropertyStringReducer from "./update_property_string_reducer";
import UpdatePropertyTimeReducer from "./update_property_time_reducer";
import UpdatePropertyUnsignedByteReducer from "./update_property_unsigned_byte_reducer";
import UpdatePropertyUnsignedIntegerReducer from "./update_property_unsigned_integer_reducer";
import UpdatePropertyUnsignedLongReducer from "./update_property_unsigned_long_reducer";
import UpdatePropertyUnsignedShortReducer from "./update_property_unsigned_short_reducer";
import UpdatePropertyUuidReducer from "./update_property_uuid_reducer";
import UpdateRelationshipCascadeRuleReducer from "./update_relationship_cascade_rule_reducer";
import UpdateRelationshipPropertyBooleanReducer from "./update_relationship_property_boolean_reducer";
import UpdateRelationshipPropertyByteReducer from "./update_relationship_property_byte_reducer";
import UpdateRelationshipPropertyBytesReducer from "./update_relationship_property_bytes_reducer";
import UpdateRelationshipPropertyComplexReducer from "./update_relationship_property_complex_reducer";
import UpdateRelationshipPropertyDateReducer from "./update_relationship_property_date_reducer";
import UpdateRelationshipPropertyDateTimeReducer from "./update_relationship_property_date_time_reducer";
import UpdateRelationshipPropertyDecimalReducer from "./update_relationship_property_decimal_reducer";
import UpdateRelationshipPropertyDoubleReducer from "./update_relationship_property_double_reducer";
import UpdateRelationshipPropertyDurationReducer from "./update_relationship_property_duration_reducer";
import UpdateRelationshipPropertyFloatReducer from "./update_relationship_property_float_reducer";
import UpdateRelationshipPropertyIntegerReducer from "./update_relationship_property_integer_reducer";
import UpdateRelationshipPropertyLongReducer from "./update_relationship_property_long_reducer";
import UpdateRelationshipPropertyShortReducer from "./update_relationship_property_short_reducer";
import UpdateRelationshipPropertyStringReducer from "./update_relationship_property_string_reducer";
import UpdateRelationshipPropertyTimeReducer from "./update_relationship_property_time_reducer";
import UpdateRelationshipPropertyUnsignedByteReducer from "./update_relationship_property_unsigned_byte_reducer";
import UpdateRelationshipPropertyUnsignedIntegerReducer from "./update_relationship_property_unsigned_integer_reducer";
import UpdateRelationshipPropertyUnsignedLongReducer from "./update_relationship_property_unsigned_long_reducer";
import UpdateRelationshipPropertyUnsignedShortReducer from "./update_relationship_property_unsigned_short_reducer";
import UpdateRelationshipPropertyUuidReducer from "./update_relationship_property_uuid_reducer";
import UpdateTwinDynamicLocationStreamNameReducer from "./update_twin_dynamic_location_stream_name_reducer";
import UpdateTwinFromJsonReducer from "./update_twin_from_json_reducer";
import UpdateTwinGeometryBindingReducer from "./update_twin_geometry_binding_reducer";
import UpdateTwinLocationModeReducer from "./update_twin_location_mode_reducer";
import UpdateTwinPropertiesFromJsonReducer from "./update_twin_properties_from_json_reducer";
import UpdateTwinStaticLocationReducer from "./update_twin_static_location_reducer";
import UpdateTwinStaticOrientationReducer from "./update_twin_static_orientation_reducer";
import UpdateTwinTelemetryLinkStreamNameReducer from "./update_twin_telemetry_link_stream_name_reducer";
import ValidateDataIntegrityReducer from "./validate_data_integrity_reducer";

// Import all procedure arg schemas
import * as BackfillTwinPositionProcedure from "./backfill_twin_position_procedure";
import * as CoreTablesAsOfProcedure from "./core_tables_as_of_procedure";
import * as EditDiffProcedure from "./edit_diff_procedure";
import * as FindTwinPathProcedure from "./find_twin_path_procedure";
import * as GetImpactZoneProcedure from "./get_impact_zone_procedure";
import * as GetTwinAncestorsProcedure from "./get_twin_ancestors_procedure";
import * as GetTwinSubtreeProcedure from "./get_twin_subtree_procedure";
import * as GraphCommitTimestampsProcedure from "./graph_commit_timestamps_procedure";
import * as JournalHistoryProcedure from "./journal_history_procedure";
import * as MatchSceneNodesToTwinsProcedure from "./match_scene_nodes_to_twins_procedure";
import * as UndoBeforeStateProcedure from "./undo_before_state_procedure";
import * as UndoTwinDeletionProcedure from "./undo_twin_deletion_procedure";

// Import all table schema definitions
import ComplexPropertyRow from "./complex_property_table";
import DigitalTwinRow from "./digital_twin_table";
import DigitalTwinOrphanedRow from "./digital_twin_orphaned_table";
import DtdlComponentRow from "./dtdl_component_table";
import DtdlExtendsRow from "./dtdl_extends_table";
import DtdlInheritanceChainRow from "./dtdl_inheritance_chain_table";
import DtdlInterfaceRow from "./dtdl_interface_table";
import DtdlPropertyRow from "./dtdl_property_table";
import DtdlRelationshipRow from "./dtdl_relationship_table";
import DtdlTelemetryRow from "./dtdl_telemetry_table";
import EditJournalRow from "./edit_journal_table";
import ExportResultEventRow from "./export_result_event_table";
import ImportDryRunResultEventRow from "./import_dry_run_result_event_table";
import ImportMappingProgressEventRow from "./import_mapping_progress_event_table";
import ImportMappingRequestEventRow from "./import_mapping_request_event_table";
import ImportMappingResultEventRow from "./import_mapping_result_event_table";
import ImportRunRow from "./import_run_table";
import ImportTemplateRow from "./import_template_table";
import ImportWarningRow from "./import_warning_table";
import ModelAssetBindingRow from "./model_asset_binding_table";
import ModelDofLinkRow from "./model_dof_link_table";
import ModelUeClassRow from "./model_ue_class_table";
import ModelVersionsRow from "./model_versions_table";
import ModuleUserRow from "./module_user_table";
import MyProjectBackgroundLayerKeysRow from "./my_project_background_layer_keys_table";
import PrimitivePropertyBoolRow from "./primitive_property_bool_table";
import PrimitivePropertyByteRow from "./primitive_property_byte_table";
import PrimitivePropertyBytesRow from "./primitive_property_bytes_table";
import PrimitivePropertyDateRow from "./primitive_property_date_table";
import PrimitivePropertyDateTimeRow from "./primitive_property_date_time_table";
import PrimitivePropertyDecimalRow from "./primitive_property_decimal_table";
import PrimitivePropertyDoubleRow from "./primitive_property_double_table";
import PrimitivePropertyDurationRow from "./primitive_property_duration_table";
import PrimitivePropertyFloatRow from "./primitive_property_float_table";
import PrimitivePropertyIntegerRow from "./primitive_property_integer_table";
import PrimitivePropertyLongRow from "./primitive_property_long_table";
import PrimitivePropertyShortRow from "./primitive_property_short_table";
import PrimitivePropertyStringRow from "./primitive_property_string_table";
import PrimitivePropertyTimeRow from "./primitive_property_time_table";
import PrimitivePropertyUnsignedByteRow from "./primitive_property_unsigned_byte_table";
import PrimitivePropertyUnsignedIntegerRow from "./primitive_property_unsigned_integer_table";
import PrimitivePropertyUnsignedLongRow from "./primitive_property_unsigned_long_table";
import PrimitivePropertyUnsignedShortRow from "./primitive_property_unsigned_short_table";
import PrimitivePropertyUuidRow from "./primitive_property_uuid_table";
import ProjectBackgroundLayerRow from "./project_background_layer_table";
import ProjectConfigRow from "./project_config_table";
import ProjectControlPointRow from "./project_control_point_table";
import ProjectSurfaceRow from "./project_surface_table";
import ProjectSurfaceClientStateRow from "./project_surface_client_state_table";
import RelationshipCascadeRuleRow from "./relationship_cascade_rule_table";
import SystemConfigRow from "./system_config_table";
import TurbotwinMetadataRow from "./turbotwin_metadata_table";
import TwinAssetBindingRow from "./twin_asset_binding_table";
import TwinComponentRow from "./twin_component_table";
import TwinDofBindingRow from "./twin_dof_binding_table";
import TwinDofLinkRow from "./twin_dof_link_table";
import TwinGeometryBindingRow from "./twin_geometry_binding_table";
import TwinPositionRow from "./twin_position_table";
import TwinPropertyRow from "./twin_property_table";
import TwinRelationshipInstanceRow from "./twin_relationship_instance_table";
import TwinTelemetryLinkRow from "./twin_telemetry_link_table";
import TwinUeClassRow from "./twin_ue_class_table";
import UeProjectConfigRow from "./ue_project_config_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  complexProperty: __table({
    name: 'complex_property',
    indexes: [
      { accessor: 'name', name: 'complex_property_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'property_id', name: 'complex_property_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'complex_property_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'complex_property_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, ComplexPropertyRow),
  digitalTwin: __table({
    name: 'digital_twin',
    indexes: [
      { accessor: 'dtmi', name: 'digital_twin_dtmi_idx_btree', algorithm: 'btree', columns: [
        'dtmi',
      ] },
      { accessor: 'twin_id', name: 'digital_twin_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'digital_twin_twin_id_key', constraint: 'unique', columns: ['twinId'] },
    ],
  }, DigitalTwinRow),
  digitalTwinOrphaned: __table({
    name: 'digital_twin_orphaned',
    indexes: [
      { accessor: 'dtmi', name: 'digital_twin_orphaned_dtmi_idx_btree', algorithm: 'btree', columns: [
        'dtmi',
      ] },
      { accessor: 'twin_id', name: 'digital_twin_orphaned_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'digital_twin_orphaned_twin_id_key', constraint: 'unique', columns: ['twinId'] },
    ],
  }, DigitalTwinOrphanedRow),
  dtdlComponent: __table({
    name: 'dtdl_component',
    indexes: [
      { accessor: 'id', name: 'dtdl_component_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'name', name: 'dtdl_component_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'parent_dtmi', name: 'dtdl_component_parent_dtmi_idx_btree', algorithm: 'btree', columns: [
        'parentDtmi',
      ] },
      { accessor: 'schema_dtmi', name: 'dtdl_component_schema_dtmi_idx_btree', algorithm: 'btree', columns: [
        'schemaDtmi',
      ] },
    ],
    constraints: [
      { name: 'dtdl_component_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DtdlComponentRow),
  dtdlExtends: __table({
    name: 'dtdl_extends',
    indexes: [
      { accessor: 'child_dtmi', name: 'dtdl_extends_child_dtmi_idx_btree', algorithm: 'btree', columns: [
        'childDtmi',
      ] },
      { accessor: 'id', name: 'dtdl_extends_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'parent_dtmi', name: 'dtdl_extends_parent_dtmi_idx_btree', algorithm: 'btree', columns: [
        'parentDtmi',
      ] },
    ],
    constraints: [
      { name: 'dtdl_extends_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DtdlExtendsRow),
  dtdlInheritanceChain: __table({
    name: 'dtdl_inheritance_chain',
    indexes: [
      { accessor: 'ancestor_dtmi', name: 'dtdl_inheritance_chain_ancestor_dtmi_idx_btree', algorithm: 'btree', columns: [
        'ancestorDtmi',
      ] },
      { accessor: 'child_ancestor_key', name: 'dtdl_inheritance_chain_child_ancestor_key_idx_btree', algorithm: 'btree', columns: [
        'childAncestorKey',
      ] },
      { accessor: 'child_dtmi', name: 'dtdl_inheritance_chain_child_dtmi_idx_btree', algorithm: 'btree', columns: [
        'childDtmi',
      ] },
      { accessor: 'id', name: 'dtdl_inheritance_chain_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'dtdl_inheritance_chain_child_ancestor_key_key', constraint: 'unique', columns: ['childAncestorKey'] },
      { name: 'dtdl_inheritance_chain_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DtdlInheritanceChainRow),
  dtdlInterface: __table({
    name: 'dtdl_interface',
    indexes: [
      { accessor: 'dtmi', name: 'dtdl_interface_dtmi_idx_btree', algorithm: 'btree', columns: [
        'dtmi',
      ] },
    ],
    constraints: [
      { name: 'dtdl_interface_dtmi_key', constraint: 'unique', columns: ['dtmi'] },
    ],
  }, DtdlInterfaceRow),
  dtdlProperty: __table({
    name: 'dtdl_property',
    indexes: [
      { accessor: 'id', name: 'dtdl_property_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'name', name: 'dtdl_property_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'parent_dtmi', name: 'dtdl_property_parent_dtmi_idx_btree', algorithm: 'btree', columns: [
        'parentDtmi',
      ] },
      { accessor: 'parent_relationship_id', name: 'dtdl_property_parent_relationship_id_idx_btree', algorithm: 'btree', columns: [
        'parentRelationshipId',
      ] },
    ],
    constraints: [
      { name: 'dtdl_property_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DtdlPropertyRow),
  dtdlRelationship: __table({
    name: 'dtdl_relationship',
    indexes: [
      { accessor: 'id', name: 'dtdl_relationship_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'name', name: 'dtdl_relationship_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'parent_dtmi', name: 'dtdl_relationship_parent_dtmi_idx_btree', algorithm: 'btree', columns: [
        'parentDtmi',
      ] },
      { accessor: 'target_dtmi', name: 'dtdl_relationship_target_dtmi_idx_btree', algorithm: 'btree', columns: [
        'targetDtmi',
      ] },
    ],
    constraints: [
      { name: 'dtdl_relationship_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DtdlRelationshipRow),
  dtdlTelemetry: __table({
    name: 'dtdl_telemetry',
    indexes: [
      { accessor: 'id', name: 'dtdl_telemetry_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'name', name: 'dtdl_telemetry_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'parent_dtmi', name: 'dtdl_telemetry_parent_dtmi_idx_btree', algorithm: 'btree', columns: [
        'parentDtmi',
      ] },
    ],
    constraints: [
      { name: 'dtdl_telemetry_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DtdlTelemetryRow),
  editJournal: __table({
    name: 'edit_journal',
    indexes: [
      { accessor: 'actor', name: 'edit_journal_actor_idx_btree', algorithm: 'btree', columns: [
        'actor',
      ] },
      { accessor: 'at', name: 'edit_journal_at_idx_btree', algorithm: 'btree', columns: [
        'at',
      ] },
      { accessor: 'edit_id', name: 'edit_journal_edit_id_idx_btree', algorithm: 'btree', columns: [
        'editId',
      ] },
    ],
    constraints: [
      { name: 'edit_journal_edit_id_key', constraint: 'unique', columns: ['editId'] },
    ],
  }, EditJournalRow),
  exportResultEvent: __table({
    name: 'export_result_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ExportResultEventRow),
  importDryRunResultEvent: __table({
    name: 'import_dry_run_result_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ImportDryRunResultEventRow),
  importMappingProgressEvent: __table({
    name: 'import_mapping_progress_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ImportMappingProgressEventRow),
  importMappingRequestEvent: __table({
    name: 'import_mapping_request_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ImportMappingRequestEventRow),
  importMappingResultEvent: __table({
    name: 'import_mapping_result_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ImportMappingResultEventRow),
  importRun: __table({
    name: 'import_run',
    indexes: [
      { accessor: 'id', name: 'import_run_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'run_id', name: 'import_run_run_id_idx_btree', algorithm: 'btree', columns: [
        'runId',
      ] },
    ],
    constraints: [
      { name: 'import_run_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'import_run_run_id_key', constraint: 'unique', columns: ['runId'] },
    ],
  }, ImportRunRow),
  importTemplate: __table({
    name: 'import_template',
    indexes: [
      { accessor: 'fingerprint', name: 'import_template_fingerprint_idx_btree', algorithm: 'btree', columns: [
        'fingerprint',
      ] },
      { accessor: 'id', name: 'import_template_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'name', name: 'import_template_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
    ],
    constraints: [
      { name: 'import_template_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'import_template_name_key', constraint: 'unique', columns: ['name'] },
    ],
  }, ImportTemplateRow),
  importWarning: __table({
    name: 'import_warning',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ImportWarningRow),
  modelAssetBinding: __table({
    name: 'model_asset_binding',
    indexes: [
      { accessor: 'dtmi', name: 'model_asset_binding_dtmi_idx_btree', algorithm: 'btree', columns: [
        'dtmi',
      ] },
    ],
    constraints: [
      { name: 'model_asset_binding_dtmi_key', constraint: 'unique', columns: ['dtmi'] },
    ],
  }, ModelAssetBindingRow),
  modelDofLink: __table({
    name: 'model_dof_link',
    indexes: [
      { accessor: 'dtmi', name: 'model_dof_link_dtmi_idx_btree', algorithm: 'btree', columns: [
        'dtmi',
      ] },
      { accessor: 'link_id', name: 'model_dof_link_link_id_idx_btree', algorithm: 'btree', columns: [
        'linkId',
      ] },
      { accessor: 'source_name', name: 'model_dof_link_source_name_idx_btree', algorithm: 'btree', columns: [
        'sourceName',
      ] },
    ],
    constraints: [
      { name: 'model_dof_link_link_id_key', constraint: 'unique', columns: ['linkId'] },
    ],
  }, ModelDofLinkRow),
  modelUeClass: __table({
    name: 'model_ue_class',
    indexes: [
      { accessor: 'dtmi', name: 'model_ue_class_dtmi_idx_btree', algorithm: 'btree', columns: [
        'dtmi',
      ] },
    ],
    constraints: [
      { name: 'model_ue_class_dtmi_key', constraint: 'unique', columns: ['dtmi'] },
    ],
  }, ModelUeClassRow),
  modelVersions: __table({
    name: 'model_versions',
    indexes: [
      { accessor: 'dtmi', name: 'model_versions_dtmi_idx_btree', algorithm: 'btree', columns: [
        'dtmi',
      ] },
      { accessor: 'status', name: 'model_versions_status_idx_btree', algorithm: 'btree', columns: [
        'status',
      ] },
      { accessor: 'version_id', name: 'model_versions_version_id_idx_btree', algorithm: 'btree', columns: [
        'versionId',
      ] },
      { accessor: 'version', name: 'model_versions_version_idx_btree', algorithm: 'btree', columns: [
        'version',
      ] },
    ],
    constraints: [
      { name: 'model_versions_version_id_key', constraint: 'unique', columns: ['versionId'] },
    ],
  }, ModelVersionsRow),
  moduleUser: __table({
    name: 'module_user',
    indexes: [
      { accessor: 'identity', name: 'module_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'module_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ModuleUserRow),
  primitivePropertyBool: __table({
    name: 'primitive_property_bool',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_bool_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_bool_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_bool_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_bool_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyBoolRow),
  primitivePropertyByte: __table({
    name: 'primitive_property_byte',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_byte_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_byte_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_byte_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_byte_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyByteRow),
  primitivePropertyBytes: __table({
    name: 'primitive_property_bytes',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_bytes_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_bytes_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_bytes_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyBytesRow),
  primitivePropertyDate: __table({
    name: 'primitive_property_date',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_date_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_date_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_date_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_date_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyDateRow),
  primitivePropertyDateTime: __table({
    name: 'primitive_property_date_time',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_date_time_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_date_time_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_date_time_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_date_time_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyDateTimeRow),
  primitivePropertyDecimal: __table({
    name: 'primitive_property_decimal',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_decimal_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_decimal_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_decimal_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_decimal_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyDecimalRow),
  primitivePropertyDouble: __table({
    name: 'primitive_property_double',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_double_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_double_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_double_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_double_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyDoubleRow),
  primitivePropertyDuration: __table({
    name: 'primitive_property_duration',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_duration_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_duration_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_duration_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_duration_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyDurationRow),
  primitivePropertyFloat: __table({
    name: 'primitive_property_float',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_float_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_float_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_float_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_float_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyFloatRow),
  primitivePropertyInteger: __table({
    name: 'primitive_property_integer',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_integer_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_integer_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_integer_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_integer_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyIntegerRow),
  primitivePropertyLong: __table({
    name: 'primitive_property_long',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_long_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_long_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_long_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_long_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyLongRow),
  primitivePropertyShort: __table({
    name: 'primitive_property_short',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_short_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_short_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_short_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_short_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyShortRow),
  primitivePropertyString: __table({
    name: 'primitive_property_string',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_string_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_string_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_string_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_string_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyStringRow),
  primitivePropertyTime: __table({
    name: 'primitive_property_time',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_time_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_time_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_time_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_time_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyTimeRow),
  primitivePropertyUnsignedByte: __table({
    name: 'primitive_property_unsigned_byte',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_unsigned_byte_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_unsigned_byte_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_unsigned_byte_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_unsigned_byte_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyUnsignedByteRow),
  primitivePropertyUnsignedInteger: __table({
    name: 'primitive_property_unsigned_integer',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_unsigned_integer_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_unsigned_integer_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_unsigned_integer_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_unsigned_integer_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyUnsignedIntegerRow),
  primitivePropertyUnsignedLong: __table({
    name: 'primitive_property_unsigned_long',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_unsigned_long_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_unsigned_long_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_unsigned_long_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_unsigned_long_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyUnsignedLongRow),
  primitivePropertyUnsignedShort: __table({
    name: 'primitive_property_unsigned_short',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_unsigned_short_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_unsigned_short_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_unsigned_short_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_unsigned_short_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyUnsignedShortRow),
  primitivePropertyUuid: __table({
    name: 'primitive_property_uuid',
    indexes: [
      { accessor: 'property_id', name: 'primitive_property_uuid_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'twin_id', name: 'primitive_property_uuid_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
      { accessor: 'value', name: 'primitive_property_uuid_value_idx_btree', algorithm: 'btree', columns: [
        'value',
      ] },
    ],
    constraints: [
      { name: 'primitive_property_uuid_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, PrimitivePropertyUuidRow),
  projectBackgroundLayer: __table({
    name: 'project_background_layer',
    indexes: [
      { accessor: 'catalog_ref', name: 'project_background_layer_catalog_ref_idx_btree', algorithm: 'btree', columns: [
        'catalogRef',
      ] },
      { accessor: 'selection_id', name: 'project_background_layer_selection_id_idx_btree', algorithm: 'btree', columns: [
        'selectionId',
      ] },
    ],
    constraints: [
      { name: 'project_background_layer_catalog_ref_key', constraint: 'unique', columns: ['catalogRef'] },
      { name: 'project_background_layer_selection_id_key', constraint: 'unique', columns: ['selectionId'] },
    ],
  }, ProjectBackgroundLayerRow),
  projectConfig: __table({
    name: 'project_config',
    indexes: [
      { accessor: 'config_id', name: 'project_config_config_id_idx_btree', algorithm: 'btree', columns: [
        'configId',
      ] },
    ],
    constraints: [
      { name: 'project_config_config_id_key', constraint: 'unique', columns: ['configId'] },
    ],
  }, ProjectConfigRow),
  projectControlPoint: __table({
    name: 'project_control_point',
    indexes: [
      { accessor: 'name', name: 'project_control_point_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'point_id', name: 'project_control_point_point_id_idx_btree', algorithm: 'btree', columns: [
        'pointId',
      ] },
    ],
    constraints: [
      { name: 'project_control_point_name_key', constraint: 'unique', columns: ['name'] },
      { name: 'project_control_point_point_id_key', constraint: 'unique', columns: ['pointId'] },
    ],
  }, ProjectControlPointRow),
  projectSurface: __table({
    name: 'project_surface',
    indexes: [
      { accessor: 'asset_ref', name: 'project_surface_asset_ref_idx_btree', algorithm: 'btree', columns: [
        'assetRef',
      ] },
      { accessor: 'surface_id', name: 'project_surface_surface_id_idx_btree', algorithm: 'btree', columns: [
        'surfaceId',
      ] },
    ],
    constraints: [
      { name: 'project_surface_asset_ref_key', constraint: 'unique', columns: ['assetRef'] },
      { name: 'project_surface_surface_id_key', constraint: 'unique', columns: ['surfaceId'] },
    ],
  }, ProjectSurfaceRow),
  projectSurfaceClientState: __table({
    name: 'project_surface_client_state',
    indexes: [
      { accessor: 'key', name: 'project_surface_client_state_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'surface_id', name: 'project_surface_client_state_surface_id_idx_btree', algorithm: 'btree', columns: [
        'surfaceId',
      ] },
    ],
    constraints: [
      { name: 'project_surface_client_state_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, ProjectSurfaceClientStateRow),
  relationshipCascadeRule: __table({
    name: 'relationship_cascade_rule',
    indexes: [
      { accessor: 'relationship_name', name: 'relationship_cascade_rule_relationship_name_idx_btree', algorithm: 'btree', columns: [
        'relationshipName',
      ] },
      { accessor: 'rule_id', name: 'relationship_cascade_rule_rule_id_idx_btree', algorithm: 'btree', columns: [
        'ruleId',
      ] },
    ],
    constraints: [
      { name: 'relationship_cascade_rule_rule_id_key', constraint: 'unique', columns: ['ruleId'] },
    ],
  }, RelationshipCascadeRuleRow),
  systemConfig: __table({
    name: 'system_config',
    indexes: [
      { accessor: 'config_key', name: 'system_config_config_key_idx_btree', algorithm: 'btree', columns: [
        'configKey',
      ] },
    ],
    constraints: [
      { name: 'system_config_config_key_key', constraint: 'unique', columns: ['configKey'] },
    ],
  }, SystemConfigRow),
  turbotwinMetadata: __table({
    name: 'turbotwin_metadata',
    indexes: [
      { accessor: 'stream_name', name: 'turbotwin_metadata_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
      { accessor: 'twin_id', name: 'turbotwin_metadata_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'turbotwin_metadata_twin_id_key', constraint: 'unique', columns: ['twinId'] },
    ],
  }, TurbotwinMetadataRow),
  twinAssetBinding: __table({
    name: 'twin_asset_binding',
    indexes: [
      { accessor: 'twin_id', name: 'twin_asset_binding_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'twin_asset_binding_twin_id_key', constraint: 'unique', columns: ['twinId'] },
    ],
  }, TwinAssetBindingRow),
  twinComponent: __table({
    name: 'twin_component',
    indexes: [
      { accessor: 'component_name', name: 'twin_component_component_name_idx_btree', algorithm: 'btree', columns: [
        'componentName',
      ] },
      { accessor: 'id', name: 'twin_component_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'twin_id', name: 'twin_component_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'twin_component_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, TwinComponentRow),
  twinDofBinding: __table({
    name: 'twin_dof_binding',
    indexes: [
      { accessor: 'binding_id', name: 'twin_dof_binding_binding_id_idx_btree', algorithm: 'btree', columns: [
        'bindingId',
      ] },
      { accessor: 'source_name', name: 'twin_dof_binding_source_name_idx_btree', algorithm: 'btree', columns: [
        'sourceName',
      ] },
      { accessor: 'twin_id', name: 'twin_dof_binding_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'twin_dof_binding_binding_id_key', constraint: 'unique', columns: ['bindingId'] },
    ],
  }, TwinDofBindingRow),
  twinDofLink: __table({
    name: 'twin_dof_link',
    indexes: [
      { accessor: 'link_id', name: 'twin_dof_link_link_id_idx_btree', algorithm: 'btree', columns: [
        'linkId',
      ] },
      { accessor: 'stream_name', name: 'twin_dof_link_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
      { accessor: 'twin_id', name: 'twin_dof_link_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'twin_dof_link_link_id_key', constraint: 'unique', columns: ['linkId'] },
    ],
  }, TwinDofLinkRow),
  twinGeometryBinding: __table({
    name: 'twin_geometry_binding',
    indexes: [
      { accessor: 'binding_id', name: 'twin_geometry_binding_binding_id_idx_btree', algorithm: 'btree', columns: [
        'bindingId',
      ] },
      { accessor: 'twin_id', name: 'twin_geometry_binding_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'twin_geometry_binding_binding_id_key', constraint: 'unique', columns: ['bindingId'] },
    ],
  }, TwinGeometryBindingRow),
  twinPosition: __table({
    name: 'twin_position',
    indexes: [
      { accessor: 'latitude', name: 'twin_position_latitude_idx_btree', algorithm: 'btree', columns: [
        'latitude',
      ] },
      { accessor: 'longitude', name: 'twin_position_longitude_idx_btree', algorithm: 'btree', columns: [
        'longitude',
      ] },
      { accessor: 'twin_id', name: 'twin_position_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'twin_position_twin_id_key', constraint: 'unique', columns: ['twinId'] },
    ],
  }, TwinPositionRow),
  twinProperty: __table({
    name: 'twin_property',
    indexes: [
      { accessor: 'component_instance_id', name: 'twin_property_component_instance_id_idx_btree', algorithm: 'btree', columns: [
        'componentInstanceId',
      ] },
      { accessor: 'dtdl_property_id', name: 'twin_property_dtdl_property_id_idx_btree', algorithm: 'btree', columns: [
        'dtdlPropertyId',
      ] },
      { accessor: 'name', name: 'twin_property_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'property_id', name: 'twin_property_property_id_idx_btree', algorithm: 'btree', columns: [
        'propertyId',
      ] },
      { accessor: 'relationship_instance_id', name: 'twin_property_relationship_instance_id_idx_btree', algorithm: 'btree', columns: [
        'relationshipInstanceId',
      ] },
      { accessor: 'twin_id', name: 'twin_property_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'twin_property_property_id_key', constraint: 'unique', columns: ['propertyId'] },
    ],
  }, TwinPropertyRow),
  twinRelationshipInstance: __table({
    name: 'twin_relationship_instance',
    indexes: [
      { accessor: 'name', name: 'twin_relationship_instance_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'relationship_id', name: 'twin_relationship_instance_relationship_id_idx_btree', algorithm: 'btree', columns: [
        'relationshipId',
      ] },
      { accessor: 'source_twin_id', name: 'twin_relationship_instance_source_twin_id_idx_btree', algorithm: 'btree', columns: [
        'sourceTwinId',
      ] },
      { accessor: 'idx_source_name', name: 'twin_relationship_instance_source_twin_id_name_idx_btree', algorithm: 'btree', columns: [
        'sourceTwinId',
        'name',
      ] },
      { accessor: 'target_twin_id', name: 'twin_relationship_instance_target_twin_id_idx_btree', algorithm: 'btree', columns: [
        'targetTwinId',
      ] },
      { accessor: 'idx_target_name', name: 'twin_relationship_instance_target_twin_id_name_idx_btree', algorithm: 'btree', columns: [
        'targetTwinId',
        'name',
      ] },
    ],
    constraints: [
      { name: 'twin_relationship_instance_relationship_id_key', constraint: 'unique', columns: ['relationshipId'] },
    ],
  }, TwinRelationshipInstanceRow),
  twinTelemetryLink: __table({
    name: 'twin_telemetry_link',
    indexes: [
      { accessor: 'component_instance_id', name: 'twin_telemetry_link_component_instance_id_idx_btree', algorithm: 'btree', columns: [
        'componentInstanceId',
      ] },
      { accessor: 'dtdl_telemetry_id', name: 'twin_telemetry_link_dtdl_telemetry_id_idx_btree', algorithm: 'btree', columns: [
        'dtdlTelemetryId',
      ] },
      { accessor: 'link_id', name: 'twin_telemetry_link_link_id_idx_btree', algorithm: 'btree', columns: [
        'linkId',
      ] },
      { accessor: 'stream_name', name: 'twin_telemetry_link_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
      { accessor: 'telemetry_name', name: 'twin_telemetry_link_telemetry_name_idx_btree', algorithm: 'btree', columns: [
        'telemetryName',
      ] },
      { accessor: 'twin_id', name: 'twin_telemetry_link_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'twin_telemetry_link_link_id_key', constraint: 'unique', columns: ['linkId'] },
    ],
  }, TwinTelemetryLinkRow),
  twinUeClass: __table({
    name: 'twin_ue_class',
    indexes: [
      { accessor: 'twin_id', name: 'twin_ue_class_twin_id_idx_btree', algorithm: 'btree', columns: [
        'twinId',
      ] },
    ],
    constraints: [
      { name: 'twin_ue_class_twin_id_key', constraint: 'unique', columns: ['twinId'] },
    ],
  }, TwinUeClassRow),
  ueProjectConfig: __table({
    name: 'ue_project_config',
    indexes: [
      { accessor: 'config_id', name: 'ue_project_config_config_id_idx_btree', algorithm: 'btree', columns: [
        'configId',
      ] },
    ],
    constraints: [
      { name: 'ue_project_config_config_id_key', constraint: 'unique', columns: ['configId'] },
    ],
  }, UeProjectConfigRow),
  myProjectBackgroundLayerKeys: __table({
    name: 'my_project_background_layer_keys',
    indexes: [
    ],
    constraints: [
    ],
  }, MyProjectBackgroundLayerKeysRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("add_model", AddModelReducer),
  __reducerSchema("add_model_component", AddModelComponentReducer),
  __reducerSchema("add_model_property", AddModelPropertyReducer),
  __reducerSchema("add_model_relationship", AddModelRelationshipReducer),
  __reducerSchema("add_model_telemetry", AddModelTelemetryReducer),
  __reducerSchema("add_models", AddModelsReducer),
  __reducerSchema("add_models_from_json", AddModelsFromJsonReducer),
  __reducerSchema("add_project_surface", AddProjectSurfaceReducer),
  __reducerSchema("add_project_surface_scoped", AddProjectSurfaceScopedReducer),
  __reducerSchema("add_relationship", AddRelationshipReducer),
  __reducerSchema("add_relationship_cascade_rule", AddRelationshipCascadeRuleReducer),
  __reducerSchema("add_relationships", AddRelationshipsReducer),
  __reducerSchema("add_relationships_from_json", AddRelationshipsFromJsonReducer),
  __reducerSchema("add_twin", AddTwinReducer),
  __reducerSchema("add_twin_complete", AddTwinCompleteReducer),
  __reducerSchema("add_twin_geometry_binding", AddTwinGeometryBindingReducer),
  __reducerSchema("add_twin_with_metadata", AddTwinWithMetadataReducer),
  __reducerSchema("add_twins", AddTwinsReducer),
  __reducerSchema("add_twins_complete", AddTwinsCompleteReducer),
  __reducerSchema("add_twins_from_json", AddTwinsFromJsonReducer),
  __reducerSchema("add_twins_with_metadata", AddTwinsWithMetadataReducer),
  __reducerSchema("cleanup_orphaned_property_values", CleanupOrphanedPropertyValuesReducer),
  __reducerSchema("clear_all_data", ClearAllDataReducer),
  __reducerSchema("clear_all_model_asset_links", ClearAllModelAssetLinksReducer),
  __reducerSchema("clear_all_twin_asset_links", ClearAllTwinAssetLinksReducer),
  __reducerSchema("clear_all_twin_data", ClearAllTwinDataReducer),
  __reducerSchema("clear_control_points", ClearControlPointsReducer),
  __reducerSchema("clear_model_asset_links", ClearModelAssetLinksReducer),
  __reducerSchema("clear_model_dof_link", ClearModelDofLinkReducer),
  __reducerSchema("clear_project_location", ClearProjectLocationReducer),
  __reducerSchema("clear_twin_asset_links", ClearTwinAssetLinksReducer),
  __reducerSchema("clear_twin_dof_binding", ClearTwinDofBindingReducer),
  __reducerSchema("clear_twin_dof_link", ClearTwinDofLinkReducer),
  __reducerSchema("clear_twin_dynamic_location_stream_name", ClearTwinDynamicLocationStreamNameReducer),
  __reducerSchema("clear_ue_project_config", ClearUeProjectConfigReducer),
  __reducerSchema("create_model_version", CreateModelVersionReducer),
  __reducerSchema("create_turbotwin_metadata", CreateTurbotwinMetadataReducer),
  __reducerSchema("create_twin_telemetry_link", CreateTwinTelemetryLinkReducer),
  __reducerSchema("delete_all_relationships_for_twin", DeleteAllRelationshipsForTwinReducer),
  __reducerSchema("delete_import_template", DeleteImportTemplateReducer),
  __reducerSchema("delete_model", DeleteModelReducer),
  __reducerSchema("delete_model_cascade", DeleteModelCascadeReducer),
  __reducerSchema("delete_model_content", DeleteModelContentReducer),
  __reducerSchema("delete_model_version", DeleteModelVersionReducer),
  __reducerSchema("delete_relationship", DeleteRelationshipReducer),
  __reducerSchema("delete_relationship_by_twins", DeleteRelationshipByTwinsReducer),
  __reducerSchema("delete_relationship_cascade_rule", DeleteRelationshipCascadeRuleReducer),
  __reducerSchema("delete_system_config", DeleteSystemConfigReducer),
  __reducerSchema("delete_turbotwin_metadata", DeleteTurbotwinMetadataReducer),
  __reducerSchema("delete_twin", DeleteTwinReducer),
  __reducerSchema("delete_twin_property", DeleteTwinPropertyReducer),
  __reducerSchema("delete_twin_telemetry_link", DeleteTwinTelemetryLinkReducer),
  __reducerSchema("delete_twins", DeleteTwinsReducer),
  __reducerSchema("dry_run_import_dtdl_graph", DryRunImportDtdlGraphReducer),
  __reducerSchema("duplicate_twin", DuplicateTwinReducer),
  __reducerSchema("export_graph", ExportGraphReducer),
  __reducerSchema("export_model", ExportModelReducer),
  __reducerSchema("export_relationship", ExportRelationshipReducer),
  __reducerSchema("export_twin", ExportTwinReducer),
  __reducerSchema("get_module_info", GetModuleInfoReducer),
  __reducerSchema("get_telemetry_links_for_component", GetTelemetryLinksForComponentReducer),
  __reducerSchema("import_control_points", ImportControlPointsReducer),
  __reducerSchema("import_dtdl_graph_from_json", ImportDtdlGraphFromJsonReducer),
  __reducerSchema("import_dtdl_graph_from_json_with_string_modes", ImportDtdlGraphFromJsonWithStringModesReducer),
  __reducerSchema("post_restore_normalize", PostRestoreNormalizeReducer),
  __reducerSchema("promote_twin_to_surface", PromoteTwinToSurfaceReducer),
  __reducerSchema("prune_edit_journal", PruneEditJournalReducer),
  __reducerSchema("record_import_run", RecordImportRunReducer),
  __reducerSchema("register_admin_service", RegisterAdminServiceReducer),
  __reducerSchema("remove_model_asset_binding", RemoveModelAssetBindingReducer),
  __reducerSchema("remove_model_ue_class", RemoveModelUeClassReducer),
  __reducerSchema("remove_module_user", RemoveModuleUserReducer),
  __reducerSchema("remove_project_background_layer", RemoveProjectBackgroundLayerReducer),
  __reducerSchema("remove_project_surface", RemoveProjectSurfaceReducer),
  __reducerSchema("remove_twin_asset_binding", RemoveTwinAssetBindingReducer),
  __reducerSchema("remove_twin_geometry_binding", RemoveTwinGeometryBindingReducer),
  __reducerSchema("remove_twin_ue_class", RemoveTwinUeClassReducer),
  __reducerSchema("rename_model_content", RenameModelContentReducer),
  __reducerSchema("reorder_project_background_layers", ReorderProjectBackgroundLayersReducer),
  __reducerSchema("reorder_project_surfaces", ReorderProjectSurfacesReducer),
  __reducerSchema("report_import_mapping_progress", ReportImportMappingProgressReducer),
  __reducerSchema("request_import_mapping", RequestImportMappingReducer),
  __reducerSchema("restore_complex_property", RestoreComplexPropertyReducer),
  __reducerSchema("restore_digital_twin", RestoreDigitalTwinReducer),
  __reducerSchema("restore_dtdl_component", RestoreDtdlComponentReducer),
  __reducerSchema("restore_dtdl_extends", RestoreDtdlExtendsReducer),
  __reducerSchema("restore_dtdl_interface", RestoreDtdlInterfaceReducer),
  __reducerSchema("restore_dtdl_property", RestoreDtdlPropertyReducer),
  __reducerSchema("restore_dtdl_relationship", RestoreDtdlRelationshipReducer),
  __reducerSchema("restore_dtdl_telemetry", RestoreDtdlTelemetryReducer),
  __reducerSchema("restore_primitive_property_bool", RestorePrimitivePropertyBoolReducer),
  __reducerSchema("restore_primitive_property_byte", RestorePrimitivePropertyByteReducer),
  __reducerSchema("restore_primitive_property_bytes", RestorePrimitivePropertyBytesReducer),
  __reducerSchema("restore_primitive_property_date", RestorePrimitivePropertyDateReducer),
  __reducerSchema("restore_primitive_property_date_time", RestorePrimitivePropertyDateTimeReducer),
  __reducerSchema("restore_primitive_property_decimal", RestorePrimitivePropertyDecimalReducer),
  __reducerSchema("restore_primitive_property_double", RestorePrimitivePropertyDoubleReducer),
  __reducerSchema("restore_primitive_property_duration", RestorePrimitivePropertyDurationReducer),
  __reducerSchema("restore_primitive_property_float", RestorePrimitivePropertyFloatReducer),
  __reducerSchema("restore_primitive_property_integer", RestorePrimitivePropertyIntegerReducer),
  __reducerSchema("restore_primitive_property_long", RestorePrimitivePropertyLongReducer),
  __reducerSchema("restore_primitive_property_short", RestorePrimitivePropertyShortReducer),
  __reducerSchema("restore_primitive_property_string", RestorePrimitivePropertyStringReducer),
  __reducerSchema("restore_primitive_property_time", RestorePrimitivePropertyTimeReducer),
  __reducerSchema("restore_primitive_property_unsigned_byte", RestorePrimitivePropertyUnsignedByteReducer),
  __reducerSchema("restore_primitive_property_unsigned_integer", RestorePrimitivePropertyUnsignedIntegerReducer),
  __reducerSchema("restore_primitive_property_unsigned_long", RestorePrimitivePropertyUnsignedLongReducer),
  __reducerSchema("restore_primitive_property_unsigned_short", RestorePrimitivePropertyUnsignedShortReducer),
  __reducerSchema("restore_primitive_property_uuid", RestorePrimitivePropertyUuidReducer),
  __reducerSchema("restore_turbotwin_metadata", RestoreTurbotwinMetadataReducer),
  __reducerSchema("restore_twin_component", RestoreTwinComponentReducer),
  __reducerSchema("restore_twin_dof_link", RestoreTwinDofLinkReducer),
  __reducerSchema("restore_twin_position", RestoreTwinPositionReducer),
  __reducerSchema("restore_twin_property", RestoreTwinPropertyReducer),
  __reducerSchema("restore_twin_relationship_instance", RestoreTwinRelationshipInstanceReducer),
  __reducerSchema("restore_twin_telemetry_link", RestoreTwinTelemetryLinkReducer),
  __reducerSchema("retarget_relationship", RetargetRelationshipReducer),
  __reducerSchema("save_import_template", SaveImportTemplateReducer),
  __reducerSchema("set_binding_enabled", SetBindingEnabledReducer),
  __reducerSchema("set_control_point_enabled", SetControlPointEnabledReducer),
  __reducerSchema("set_edit_provenance", SetEditProvenanceReducer),
  __reducerSchema("set_first_twin_fallback", SetFirstTwinFallbackReducer),
  __reducerSchema("set_model_asset_binding", SetModelAssetBindingReducer),
  __reducerSchema("set_model_asset_binding_scoped", SetModelAssetBindingScopedReducer),
  __reducerSchema("set_model_dof_link", SetModelDofLinkReducer),
  __reducerSchema("set_model_ue_class", SetModelUeClassReducer),
  __reducerSchema("set_module_user_role", SetModuleUserRoleReducer),
  __reducerSchema("set_project_background_layer", SetProjectBackgroundLayerReducer),
  __reducerSchema("set_project_background_layer_state", SetProjectBackgroundLayerStateReducer),
  __reducerSchema("set_project_location_static", SetProjectLocationStaticReducer),
  __reducerSchema("set_project_location_twin_reference", SetProjectLocationTwinReferenceReducer),
  __reducerSchema("set_project_scope", SetProjectScopeReducer),
  __reducerSchema("set_project_surface_client_state", SetProjectSurfaceClientStateReducer),
  __reducerSchema("set_project_surface_state", SetProjectSurfaceStateReducer),
  __reducerSchema("set_project_surface_twin", SetProjectSurfaceTwinReducer),
  __reducerSchema("set_project_tenant_config", SetProjectTenantConfigReducer),
  __reducerSchema("set_startup_map", SetStartupMapReducer),
  __reducerSchema("set_system_config", SetSystemConfigReducer),
  __reducerSchema("set_twin_asset_binding", SetTwinAssetBindingReducer),
  __reducerSchema("set_twin_asset_binding_scoped", SetTwinAssetBindingScopedReducer),
  __reducerSchema("set_twin_dof_binding", SetTwinDofBindingReducer),
  __reducerSchema("set_twin_dof_link", SetTwinDofLinkReducer),
  __reducerSchema("set_twin_mesh_section", SetTwinMeshSectionReducer),
  __reducerSchema("set_twin_ue_class", SetTwinUeClassReducer),
  __reducerSchema("set_ue_project_config", SetUeProjectConfigReducer),
  __reducerSchema("submit_import_mapping", SubmitImportMappingReducer),
  __reducerSchema("transfer_admin_service", TransferAdminServiceReducer),
  __reducerSchema("undo_edit", UndoEditReducer),
  __reducerSchema("undo_import_run", UndoImportRunReducer),
  __reducerSchema("update_model", UpdateModelReducer),
  __reducerSchema("update_model_version_status", UpdateModelVersionStatusReducer),
  __reducerSchema("update_property_boolean", UpdatePropertyBooleanReducer),
  __reducerSchema("update_property_byte", UpdatePropertyByteReducer),
  __reducerSchema("update_property_bytes", UpdatePropertyBytesReducer),
  __reducerSchema("update_property_complex", UpdatePropertyComplexReducer),
  __reducerSchema("update_property_date", UpdatePropertyDateReducer),
  __reducerSchema("update_property_date_time", UpdatePropertyDateTimeReducer),
  __reducerSchema("update_property_decimal", UpdatePropertyDecimalReducer),
  __reducerSchema("update_property_double", UpdatePropertyDoubleReducer),
  __reducerSchema("update_property_duration", UpdatePropertyDurationReducer),
  __reducerSchema("update_property_float", UpdatePropertyFloatReducer),
  __reducerSchema("update_property_integer", UpdatePropertyIntegerReducer),
  __reducerSchema("update_property_long", UpdatePropertyLongReducer),
  __reducerSchema("update_property_short", UpdatePropertyShortReducer),
  __reducerSchema("update_property_string", UpdatePropertyStringReducer),
  __reducerSchema("update_property_time", UpdatePropertyTimeReducer),
  __reducerSchema("update_property_unsigned_byte", UpdatePropertyUnsignedByteReducer),
  __reducerSchema("update_property_unsigned_integer", UpdatePropertyUnsignedIntegerReducer),
  __reducerSchema("update_property_unsigned_long", UpdatePropertyUnsignedLongReducer),
  __reducerSchema("update_property_unsigned_short", UpdatePropertyUnsignedShortReducer),
  __reducerSchema("update_property_uuid", UpdatePropertyUuidReducer),
  __reducerSchema("update_relationship_cascade_rule", UpdateRelationshipCascadeRuleReducer),
  __reducerSchema("update_relationship_property_boolean", UpdateRelationshipPropertyBooleanReducer),
  __reducerSchema("update_relationship_property_byte", UpdateRelationshipPropertyByteReducer),
  __reducerSchema("update_relationship_property_bytes", UpdateRelationshipPropertyBytesReducer),
  __reducerSchema("update_relationship_property_complex", UpdateRelationshipPropertyComplexReducer),
  __reducerSchema("update_relationship_property_date", UpdateRelationshipPropertyDateReducer),
  __reducerSchema("update_relationship_property_date_time", UpdateRelationshipPropertyDateTimeReducer),
  __reducerSchema("update_relationship_property_decimal", UpdateRelationshipPropertyDecimalReducer),
  __reducerSchema("update_relationship_property_double", UpdateRelationshipPropertyDoubleReducer),
  __reducerSchema("update_relationship_property_duration", UpdateRelationshipPropertyDurationReducer),
  __reducerSchema("update_relationship_property_float", UpdateRelationshipPropertyFloatReducer),
  __reducerSchema("update_relationship_property_integer", UpdateRelationshipPropertyIntegerReducer),
  __reducerSchema("update_relationship_property_long", UpdateRelationshipPropertyLongReducer),
  __reducerSchema("update_relationship_property_short", UpdateRelationshipPropertyShortReducer),
  __reducerSchema("update_relationship_property_string", UpdateRelationshipPropertyStringReducer),
  __reducerSchema("update_relationship_property_time", UpdateRelationshipPropertyTimeReducer),
  __reducerSchema("update_relationship_property_unsigned_byte", UpdateRelationshipPropertyUnsignedByteReducer),
  __reducerSchema("update_relationship_property_unsigned_integer", UpdateRelationshipPropertyUnsignedIntegerReducer),
  __reducerSchema("update_relationship_property_unsigned_long", UpdateRelationshipPropertyUnsignedLongReducer),
  __reducerSchema("update_relationship_property_unsigned_short", UpdateRelationshipPropertyUnsignedShortReducer),
  __reducerSchema("update_relationship_property_uuid", UpdateRelationshipPropertyUuidReducer),
  __reducerSchema("update_twin_dynamic_location_stream_name", UpdateTwinDynamicLocationStreamNameReducer),
  __reducerSchema("update_twin_from_json", UpdateTwinFromJsonReducer),
  __reducerSchema("update_twin_geometry_binding", UpdateTwinGeometryBindingReducer),
  __reducerSchema("update_twin_location_mode", UpdateTwinLocationModeReducer),
  __reducerSchema("update_twin_properties_from_json", UpdateTwinPropertiesFromJsonReducer),
  __reducerSchema("update_twin_static_location", UpdateTwinStaticLocationReducer),
  __reducerSchema("update_twin_static_orientation", UpdateTwinStaticOrientationReducer),
  __reducerSchema("update_twin_telemetry_link_stream_name", UpdateTwinTelemetryLinkStreamNameReducer),
  __reducerSchema("validate_data_integrity", ValidateDataIntegrityReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
  __procedureSchema("backfill_twin_position", BackfillTwinPositionProcedure.params, BackfillTwinPositionProcedure.returnType),
  __procedureSchema("core_tables_as_of", CoreTablesAsOfProcedure.params, CoreTablesAsOfProcedure.returnType),
  __procedureSchema("edit_diff", EditDiffProcedure.params, EditDiffProcedure.returnType),
  __procedureSchema("find_twin_path", FindTwinPathProcedure.params, FindTwinPathProcedure.returnType),
  __procedureSchema("get_impact_zone", GetImpactZoneProcedure.params, GetImpactZoneProcedure.returnType),
  __procedureSchema("get_twin_ancestors", GetTwinAncestorsProcedure.params, GetTwinAncestorsProcedure.returnType),
  __procedureSchema("get_twin_subtree", GetTwinSubtreeProcedure.params, GetTwinSubtreeProcedure.returnType),
  __procedureSchema("graph_commit_timestamps", GraphCommitTimestampsProcedure.params, GraphCommitTimestampsProcedure.returnType),
  __procedureSchema("journal_history", JournalHistoryProcedure.params, JournalHistoryProcedure.returnType),
  __procedureSchema("match_scene_nodes_to_twins", MatchSceneNodesToTwinsProcedure.params, MatchSceneNodesToTwinsProcedure.returnType),
  __procedureSchema("undo_before_state", UndoBeforeStateProcedure.params, UndoBeforeStateProcedure.returnType),
  __procedureSchema("undo_twin_deletion", UndoTwinDeletionProcedure.params, UndoTwinDeletionProcedure.returnType),
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `complexProperty` instead. This alias will be removed in the next major version. */
    readonly "complex_property": Omit<typeof tablesSchema.schemaType.tables["complexProperty"], "accessorName"> & { readonly accessorName: "complex_property" };
    /** @deprecated Use `digitalTwin` instead. This alias will be removed in the next major version. */
    readonly "digital_twin": Omit<typeof tablesSchema.schemaType.tables["digitalTwin"], "accessorName"> & { readonly accessorName: "digital_twin" };
    /** @deprecated Use `digitalTwinOrphaned` instead. This alias will be removed in the next major version. */
    readonly "digital_twin_orphaned": Omit<typeof tablesSchema.schemaType.tables["digitalTwinOrphaned"], "accessorName"> & { readonly accessorName: "digital_twin_orphaned" };
    /** @deprecated Use `dtdlComponent` instead. This alias will be removed in the next major version. */
    readonly "dtdl_component": Omit<typeof tablesSchema.schemaType.tables["dtdlComponent"], "accessorName"> & { readonly accessorName: "dtdl_component" };
    /** @deprecated Use `dtdlExtends` instead. This alias will be removed in the next major version. */
    readonly "dtdl_extends": Omit<typeof tablesSchema.schemaType.tables["dtdlExtends"], "accessorName"> & { readonly accessorName: "dtdl_extends" };
    /** @deprecated Use `dtdlInheritanceChain` instead. This alias will be removed in the next major version. */
    readonly "dtdl_inheritance_chain": Omit<typeof tablesSchema.schemaType.tables["dtdlInheritanceChain"], "accessorName"> & { readonly accessorName: "dtdl_inheritance_chain" };
    /** @deprecated Use `dtdlInterface` instead. This alias will be removed in the next major version. */
    readonly "dtdl_interface": Omit<typeof tablesSchema.schemaType.tables["dtdlInterface"], "accessorName"> & { readonly accessorName: "dtdl_interface" };
    /** @deprecated Use `dtdlProperty` instead. This alias will be removed in the next major version. */
    readonly "dtdl_property": Omit<typeof tablesSchema.schemaType.tables["dtdlProperty"], "accessorName"> & { readonly accessorName: "dtdl_property" };
    /** @deprecated Use `dtdlRelationship` instead. This alias will be removed in the next major version. */
    readonly "dtdl_relationship": Omit<typeof tablesSchema.schemaType.tables["dtdlRelationship"], "accessorName"> & { readonly accessorName: "dtdl_relationship" };
    /** @deprecated Use `dtdlTelemetry` instead. This alias will be removed in the next major version. */
    readonly "dtdl_telemetry": Omit<typeof tablesSchema.schemaType.tables["dtdlTelemetry"], "accessorName"> & { readonly accessorName: "dtdl_telemetry" };
    /** @deprecated Use `editJournal` instead. This alias will be removed in the next major version. */
    readonly "edit_journal": Omit<typeof tablesSchema.schemaType.tables["editJournal"], "accessorName"> & { readonly accessorName: "edit_journal" };
    /** @deprecated Use `exportResultEvent` instead. This alias will be removed in the next major version. */
    readonly "export_result_event": Omit<typeof tablesSchema.schemaType.tables["exportResultEvent"], "accessorName"> & { readonly accessorName: "export_result_event" };
    /** @deprecated Use `importDryRunResultEvent` instead. This alias will be removed in the next major version. */
    readonly "import_dry_run_result_event": Omit<typeof tablesSchema.schemaType.tables["importDryRunResultEvent"], "accessorName"> & { readonly accessorName: "import_dry_run_result_event" };
    /** @deprecated Use `importMappingProgressEvent` instead. This alias will be removed in the next major version. */
    readonly "import_mapping_progress_event": Omit<typeof tablesSchema.schemaType.tables["importMappingProgressEvent"], "accessorName"> & { readonly accessorName: "import_mapping_progress_event" };
    /** @deprecated Use `importMappingRequestEvent` instead. This alias will be removed in the next major version. */
    readonly "import_mapping_request_event": Omit<typeof tablesSchema.schemaType.tables["importMappingRequestEvent"], "accessorName"> & { readonly accessorName: "import_mapping_request_event" };
    /** @deprecated Use `importMappingResultEvent` instead. This alias will be removed in the next major version. */
    readonly "import_mapping_result_event": Omit<typeof tablesSchema.schemaType.tables["importMappingResultEvent"], "accessorName"> & { readonly accessorName: "import_mapping_result_event" };
    /** @deprecated Use `importRun` instead. This alias will be removed in the next major version. */
    readonly "import_run": Omit<typeof tablesSchema.schemaType.tables["importRun"], "accessorName"> & { readonly accessorName: "import_run" };
    /** @deprecated Use `importTemplate` instead. This alias will be removed in the next major version. */
    readonly "import_template": Omit<typeof tablesSchema.schemaType.tables["importTemplate"], "accessorName"> & { readonly accessorName: "import_template" };
    /** @deprecated Use `importWarning` instead. This alias will be removed in the next major version. */
    readonly "import_warning": Omit<typeof tablesSchema.schemaType.tables["importWarning"], "accessorName"> & { readonly accessorName: "import_warning" };
    /** @deprecated Use `modelAssetBinding` instead. This alias will be removed in the next major version. */
    readonly "model_asset_binding": Omit<typeof tablesSchema.schemaType.tables["modelAssetBinding"], "accessorName"> & { readonly accessorName: "model_asset_binding" };
    /** @deprecated Use `modelDofLink` instead. This alias will be removed in the next major version. */
    readonly "model_dof_link": Omit<typeof tablesSchema.schemaType.tables["modelDofLink"], "accessorName"> & { readonly accessorName: "model_dof_link" };
    /** @deprecated Use `modelUeClass` instead. This alias will be removed in the next major version. */
    readonly "model_ue_class": Omit<typeof tablesSchema.schemaType.tables["modelUeClass"], "accessorName"> & { readonly accessorName: "model_ue_class" };
    /** @deprecated Use `modelVersions` instead. This alias will be removed in the next major version. */
    readonly "model_versions": Omit<typeof tablesSchema.schemaType.tables["modelVersions"], "accessorName"> & { readonly accessorName: "model_versions" };
    /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
    readonly "module_user": Omit<typeof tablesSchema.schemaType.tables["moduleUser"], "accessorName"> & { readonly accessorName: "module_user" };
    /** @deprecated Use `primitivePropertyBool` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_bool": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyBool"], "accessorName"> & { readonly accessorName: "primitive_property_bool" };
    /** @deprecated Use `primitivePropertyByte` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_byte": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyByte"], "accessorName"> & { readonly accessorName: "primitive_property_byte" };
    /** @deprecated Use `primitivePropertyBytes` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_bytes": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyBytes"], "accessorName"> & { readonly accessorName: "primitive_property_bytes" };
    /** @deprecated Use `primitivePropertyDate` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_date": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyDate"], "accessorName"> & { readonly accessorName: "primitive_property_date" };
    /** @deprecated Use `primitivePropertyDateTime` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_date_time": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyDateTime"], "accessorName"> & { readonly accessorName: "primitive_property_date_time" };
    /** @deprecated Use `primitivePropertyDecimal` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_decimal": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyDecimal"], "accessorName"> & { readonly accessorName: "primitive_property_decimal" };
    /** @deprecated Use `primitivePropertyDouble` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_double": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyDouble"], "accessorName"> & { readonly accessorName: "primitive_property_double" };
    /** @deprecated Use `primitivePropertyDuration` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_duration": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyDuration"], "accessorName"> & { readonly accessorName: "primitive_property_duration" };
    /** @deprecated Use `primitivePropertyFloat` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_float": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyFloat"], "accessorName"> & { readonly accessorName: "primitive_property_float" };
    /** @deprecated Use `primitivePropertyInteger` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_integer": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyInteger"], "accessorName"> & { readonly accessorName: "primitive_property_integer" };
    /** @deprecated Use `primitivePropertyLong` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_long": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyLong"], "accessorName"> & { readonly accessorName: "primitive_property_long" };
    /** @deprecated Use `primitivePropertyShort` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_short": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyShort"], "accessorName"> & { readonly accessorName: "primitive_property_short" };
    /** @deprecated Use `primitivePropertyString` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_string": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyString"], "accessorName"> & { readonly accessorName: "primitive_property_string" };
    /** @deprecated Use `primitivePropertyTime` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_time": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyTime"], "accessorName"> & { readonly accessorName: "primitive_property_time" };
    /** @deprecated Use `primitivePropertyUnsignedByte` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_unsigned_byte": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyUnsignedByte"], "accessorName"> & { readonly accessorName: "primitive_property_unsigned_byte" };
    /** @deprecated Use `primitivePropertyUnsignedInteger` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_unsigned_integer": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyUnsignedInteger"], "accessorName"> & { readonly accessorName: "primitive_property_unsigned_integer" };
    /** @deprecated Use `primitivePropertyUnsignedLong` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_unsigned_long": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyUnsignedLong"], "accessorName"> & { readonly accessorName: "primitive_property_unsigned_long" };
    /** @deprecated Use `primitivePropertyUnsignedShort` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_unsigned_short": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyUnsignedShort"], "accessorName"> & { readonly accessorName: "primitive_property_unsigned_short" };
    /** @deprecated Use `primitivePropertyUuid` instead. This alias will be removed in the next major version. */
    readonly "primitive_property_uuid": Omit<typeof tablesSchema.schemaType.tables["primitivePropertyUuid"], "accessorName"> & { readonly accessorName: "primitive_property_uuid" };
    /** @deprecated Use `projectBackgroundLayer` instead. This alias will be removed in the next major version. */
    readonly "project_background_layer": Omit<typeof tablesSchema.schemaType.tables["projectBackgroundLayer"], "accessorName"> & { readonly accessorName: "project_background_layer" };
    /** @deprecated Use `projectConfig` instead. This alias will be removed in the next major version. */
    readonly "project_config": Omit<typeof tablesSchema.schemaType.tables["projectConfig"], "accessorName"> & { readonly accessorName: "project_config" };
    /** @deprecated Use `projectControlPoint` instead. This alias will be removed in the next major version. */
    readonly "project_control_point": Omit<typeof tablesSchema.schemaType.tables["projectControlPoint"], "accessorName"> & { readonly accessorName: "project_control_point" };
    /** @deprecated Use `projectSurface` instead. This alias will be removed in the next major version. */
    readonly "project_surface": Omit<typeof tablesSchema.schemaType.tables["projectSurface"], "accessorName"> & { readonly accessorName: "project_surface" };
    /** @deprecated Use `projectSurfaceClientState` instead. This alias will be removed in the next major version. */
    readonly "project_surface_client_state": Omit<typeof tablesSchema.schemaType.tables["projectSurfaceClientState"], "accessorName"> & { readonly accessorName: "project_surface_client_state" };
    /** @deprecated Use `relationshipCascadeRule` instead. This alias will be removed in the next major version. */
    readonly "relationship_cascade_rule": Omit<typeof tablesSchema.schemaType.tables["relationshipCascadeRule"], "accessorName"> & { readonly accessorName: "relationship_cascade_rule" };
    /** @deprecated Use `systemConfig` instead. This alias will be removed in the next major version. */
    readonly "system_config": Omit<typeof tablesSchema.schemaType.tables["systemConfig"], "accessorName"> & { readonly accessorName: "system_config" };
    /** @deprecated Use `turbotwinMetadata` instead. This alias will be removed in the next major version. */
    readonly "turbotwin_metadata": Omit<typeof tablesSchema.schemaType.tables["turbotwinMetadata"], "accessorName"> & { readonly accessorName: "turbotwin_metadata" };
    /** @deprecated Use `twinAssetBinding` instead. This alias will be removed in the next major version. */
    readonly "twin_asset_binding": Omit<typeof tablesSchema.schemaType.tables["twinAssetBinding"], "accessorName"> & { readonly accessorName: "twin_asset_binding" };
    /** @deprecated Use `twinComponent` instead. This alias will be removed in the next major version. */
    readonly "twin_component": Omit<typeof tablesSchema.schemaType.tables["twinComponent"], "accessorName"> & { readonly accessorName: "twin_component" };
    /** @deprecated Use `twinDofBinding` instead. This alias will be removed in the next major version. */
    readonly "twin_dof_binding": Omit<typeof tablesSchema.schemaType.tables["twinDofBinding"], "accessorName"> & { readonly accessorName: "twin_dof_binding" };
    /** @deprecated Use `twinDofLink` instead. This alias will be removed in the next major version. */
    readonly "twin_dof_link": Omit<typeof tablesSchema.schemaType.tables["twinDofLink"], "accessorName"> & { readonly accessorName: "twin_dof_link" };
    /** @deprecated Use `twinGeometryBinding` instead. This alias will be removed in the next major version. */
    readonly "twin_geometry_binding": Omit<typeof tablesSchema.schemaType.tables["twinGeometryBinding"], "accessorName"> & { readonly accessorName: "twin_geometry_binding" };
    /** @deprecated Use `twinPosition` instead. This alias will be removed in the next major version. */
    readonly "twin_position": Omit<typeof tablesSchema.schemaType.tables["twinPosition"], "accessorName"> & { readonly accessorName: "twin_position" };
    /** @deprecated Use `twinProperty` instead. This alias will be removed in the next major version. */
    readonly "twin_property": Omit<typeof tablesSchema.schemaType.tables["twinProperty"], "accessorName"> & { readonly accessorName: "twin_property" };
    /** @deprecated Use `twinRelationshipInstance` instead. This alias will be removed in the next major version. */
    readonly "twin_relationship_instance": Omit<typeof tablesSchema.schemaType.tables["twinRelationshipInstance"], "accessorName"> & { readonly accessorName: "twin_relationship_instance" };
    /** @deprecated Use `twinTelemetryLink` instead. This alias will be removed in the next major version. */
    readonly "twin_telemetry_link": Omit<typeof tablesSchema.schemaType.tables["twinTelemetryLink"], "accessorName"> & { readonly accessorName: "twin_telemetry_link" };
    /** @deprecated Use `twinUeClass` instead. This alias will be removed in the next major version. */
    readonly "twin_ue_class": Omit<typeof tablesSchema.schemaType.tables["twinUeClass"], "accessorName"> & { readonly accessorName: "twin_ue_class" };
    /** @deprecated Use `ueProjectConfig` instead. This alias will be removed in the next major version. */
    readonly "ue_project_config": Omit<typeof tablesSchema.schemaType.tables["ueProjectConfig"], "accessorName"> & { readonly accessorName: "ue_project_config" };
    /** @deprecated Use `myProjectBackgroundLayerKeys` instead. This alias will be removed in the next major version. */
    readonly "my_project_background_layer_keys": Omit<typeof tablesSchema.schemaType.tables["myProjectBackgroundLayerKeys"], "accessorName"> & { readonly accessorName: "my_project_background_layer_keys" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.14.0" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "complex_property": "complexProperty",
  "digital_twin": "digitalTwin",
  "digital_twin_orphaned": "digitalTwinOrphaned",
  "dtdl_component": "dtdlComponent",
  "dtdl_extends": "dtdlExtends",
  "dtdl_inheritance_chain": "dtdlInheritanceChain",
  "dtdl_interface": "dtdlInterface",
  "dtdl_property": "dtdlProperty",
  "dtdl_relationship": "dtdlRelationship",
  "dtdl_telemetry": "dtdlTelemetry",
  "edit_journal": "editJournal",
  "export_result_event": "exportResultEvent",
  "import_dry_run_result_event": "importDryRunResultEvent",
  "import_mapping_progress_event": "importMappingProgressEvent",
  "import_mapping_request_event": "importMappingRequestEvent",
  "import_mapping_result_event": "importMappingResultEvent",
  "import_run": "importRun",
  "import_template": "importTemplate",
  "import_warning": "importWarning",
  "model_asset_binding": "modelAssetBinding",
  "model_dof_link": "modelDofLink",
  "model_ue_class": "modelUeClass",
  "model_versions": "modelVersions",
  "module_user": "moduleUser",
  "primitive_property_bool": "primitivePropertyBool",
  "primitive_property_byte": "primitivePropertyByte",
  "primitive_property_bytes": "primitivePropertyBytes",
  "primitive_property_date": "primitivePropertyDate",
  "primitive_property_date_time": "primitivePropertyDateTime",
  "primitive_property_decimal": "primitivePropertyDecimal",
  "primitive_property_double": "primitivePropertyDouble",
  "primitive_property_duration": "primitivePropertyDuration",
  "primitive_property_float": "primitivePropertyFloat",
  "primitive_property_integer": "primitivePropertyInteger",
  "primitive_property_long": "primitivePropertyLong",
  "primitive_property_short": "primitivePropertyShort",
  "primitive_property_string": "primitivePropertyString",
  "primitive_property_time": "primitivePropertyTime",
  "primitive_property_unsigned_byte": "primitivePropertyUnsignedByte",
  "primitive_property_unsigned_integer": "primitivePropertyUnsignedInteger",
  "primitive_property_unsigned_long": "primitivePropertyUnsignedLong",
  "primitive_property_unsigned_short": "primitivePropertyUnsignedShort",
  "primitive_property_uuid": "primitivePropertyUuid",
  "project_background_layer": "projectBackgroundLayer",
  "project_config": "projectConfig",
  "project_control_point": "projectControlPoint",
  "project_surface": "projectSurface",
  "project_surface_client_state": "projectSurfaceClientState",
  "relationship_cascade_rule": "relationshipCascadeRule",
  "system_config": "systemConfig",
  "turbotwin_metadata": "turbotwinMetadata",
  "twin_asset_binding": "twinAssetBinding",
  "twin_component": "twinComponent",
  "twin_dof_binding": "twinDofBinding",
  "twin_dof_link": "twinDofLink",
  "twin_geometry_binding": "twinGeometryBinding",
  "twin_position": "twinPosition",
  "twin_property": "twinProperty",
  "twin_relationship_instance": "twinRelationshipInstance",
  "twin_telemetry_link": "twinTelemetryLink",
  "twin_ue_class": "twinUeClass",
  "ue_project_config": "ueProjectConfig",
  "my_project_background_layer_keys": "myProjectBackgroundLayerKeys",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `complexProperty` instead. This alias will be removed in the next major version. */
  readonly "complex_property": __DbViewBase["complexProperty"];
  /** @deprecated Use `digitalTwin` instead. This alias will be removed in the next major version. */
  readonly "digital_twin": __DbViewBase["digitalTwin"];
  /** @deprecated Use `digitalTwinOrphaned` instead. This alias will be removed in the next major version. */
  readonly "digital_twin_orphaned": __DbViewBase["digitalTwinOrphaned"];
  /** @deprecated Use `dtdlComponent` instead. This alias will be removed in the next major version. */
  readonly "dtdl_component": __DbViewBase["dtdlComponent"];
  /** @deprecated Use `dtdlExtends` instead. This alias will be removed in the next major version. */
  readonly "dtdl_extends": __DbViewBase["dtdlExtends"];
  /** @deprecated Use `dtdlInheritanceChain` instead. This alias will be removed in the next major version. */
  readonly "dtdl_inheritance_chain": __DbViewBase["dtdlInheritanceChain"];
  /** @deprecated Use `dtdlInterface` instead. This alias will be removed in the next major version. */
  readonly "dtdl_interface": __DbViewBase["dtdlInterface"];
  /** @deprecated Use `dtdlProperty` instead. This alias will be removed in the next major version. */
  readonly "dtdl_property": __DbViewBase["dtdlProperty"];
  /** @deprecated Use `dtdlRelationship` instead. This alias will be removed in the next major version. */
  readonly "dtdl_relationship": __DbViewBase["dtdlRelationship"];
  /** @deprecated Use `dtdlTelemetry` instead. This alias will be removed in the next major version. */
  readonly "dtdl_telemetry": __DbViewBase["dtdlTelemetry"];
  /** @deprecated Use `editJournal` instead. This alias will be removed in the next major version. */
  readonly "edit_journal": __DbViewBase["editJournal"];
  /** @deprecated Use `exportResultEvent` instead. This alias will be removed in the next major version. */
  readonly "export_result_event": __DbViewBase["exportResultEvent"];
  /** @deprecated Use `importDryRunResultEvent` instead. This alias will be removed in the next major version. */
  readonly "import_dry_run_result_event": __DbViewBase["importDryRunResultEvent"];
  /** @deprecated Use `importMappingProgressEvent` instead. This alias will be removed in the next major version. */
  readonly "import_mapping_progress_event": __DbViewBase["importMappingProgressEvent"];
  /** @deprecated Use `importMappingRequestEvent` instead. This alias will be removed in the next major version. */
  readonly "import_mapping_request_event": __DbViewBase["importMappingRequestEvent"];
  /** @deprecated Use `importMappingResultEvent` instead. This alias will be removed in the next major version. */
  readonly "import_mapping_result_event": __DbViewBase["importMappingResultEvent"];
  /** @deprecated Use `importRun` instead. This alias will be removed in the next major version. */
  readonly "import_run": __DbViewBase["importRun"];
  /** @deprecated Use `importTemplate` instead. This alias will be removed in the next major version. */
  readonly "import_template": __DbViewBase["importTemplate"];
  /** @deprecated Use `importWarning` instead. This alias will be removed in the next major version. */
  readonly "import_warning": __DbViewBase["importWarning"];
  /** @deprecated Use `modelAssetBinding` instead. This alias will be removed in the next major version. */
  readonly "model_asset_binding": __DbViewBase["modelAssetBinding"];
  /** @deprecated Use `modelDofLink` instead. This alias will be removed in the next major version. */
  readonly "model_dof_link": __DbViewBase["modelDofLink"];
  /** @deprecated Use `modelUeClass` instead. This alias will be removed in the next major version. */
  readonly "model_ue_class": __DbViewBase["modelUeClass"];
  /** @deprecated Use `modelVersions` instead. This alias will be removed in the next major version. */
  readonly "model_versions": __DbViewBase["modelVersions"];
  /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
  readonly "module_user": __DbViewBase["moduleUser"];
  /** @deprecated Use `primitivePropertyBool` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_bool": __DbViewBase["primitivePropertyBool"];
  /** @deprecated Use `primitivePropertyByte` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_byte": __DbViewBase["primitivePropertyByte"];
  /** @deprecated Use `primitivePropertyBytes` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_bytes": __DbViewBase["primitivePropertyBytes"];
  /** @deprecated Use `primitivePropertyDate` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_date": __DbViewBase["primitivePropertyDate"];
  /** @deprecated Use `primitivePropertyDateTime` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_date_time": __DbViewBase["primitivePropertyDateTime"];
  /** @deprecated Use `primitivePropertyDecimal` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_decimal": __DbViewBase["primitivePropertyDecimal"];
  /** @deprecated Use `primitivePropertyDouble` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_double": __DbViewBase["primitivePropertyDouble"];
  /** @deprecated Use `primitivePropertyDuration` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_duration": __DbViewBase["primitivePropertyDuration"];
  /** @deprecated Use `primitivePropertyFloat` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_float": __DbViewBase["primitivePropertyFloat"];
  /** @deprecated Use `primitivePropertyInteger` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_integer": __DbViewBase["primitivePropertyInteger"];
  /** @deprecated Use `primitivePropertyLong` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_long": __DbViewBase["primitivePropertyLong"];
  /** @deprecated Use `primitivePropertyShort` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_short": __DbViewBase["primitivePropertyShort"];
  /** @deprecated Use `primitivePropertyString` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_string": __DbViewBase["primitivePropertyString"];
  /** @deprecated Use `primitivePropertyTime` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_time": __DbViewBase["primitivePropertyTime"];
  /** @deprecated Use `primitivePropertyUnsignedByte` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_unsigned_byte": __DbViewBase["primitivePropertyUnsignedByte"];
  /** @deprecated Use `primitivePropertyUnsignedInteger` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_unsigned_integer": __DbViewBase["primitivePropertyUnsignedInteger"];
  /** @deprecated Use `primitivePropertyUnsignedLong` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_unsigned_long": __DbViewBase["primitivePropertyUnsignedLong"];
  /** @deprecated Use `primitivePropertyUnsignedShort` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_unsigned_short": __DbViewBase["primitivePropertyUnsignedShort"];
  /** @deprecated Use `primitivePropertyUuid` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_uuid": __DbViewBase["primitivePropertyUuid"];
  /** @deprecated Use `projectBackgroundLayer` instead. This alias will be removed in the next major version. */
  readonly "project_background_layer": __DbViewBase["projectBackgroundLayer"];
  /** @deprecated Use `projectConfig` instead. This alias will be removed in the next major version. */
  readonly "project_config": __DbViewBase["projectConfig"];
  /** @deprecated Use `projectControlPoint` instead. This alias will be removed in the next major version. */
  readonly "project_control_point": __DbViewBase["projectControlPoint"];
  /** @deprecated Use `projectSurface` instead. This alias will be removed in the next major version. */
  readonly "project_surface": __DbViewBase["projectSurface"];
  /** @deprecated Use `projectSurfaceClientState` instead. This alias will be removed in the next major version. */
  readonly "project_surface_client_state": __DbViewBase["projectSurfaceClientState"];
  /** @deprecated Use `relationshipCascadeRule` instead. This alias will be removed in the next major version. */
  readonly "relationship_cascade_rule": __DbViewBase["relationshipCascadeRule"];
  /** @deprecated Use `systemConfig` instead. This alias will be removed in the next major version. */
  readonly "system_config": __DbViewBase["systemConfig"];
  /** @deprecated Use `turbotwinMetadata` instead. This alias will be removed in the next major version. */
  readonly "turbotwin_metadata": __DbViewBase["turbotwinMetadata"];
  /** @deprecated Use `twinAssetBinding` instead. This alias will be removed in the next major version. */
  readonly "twin_asset_binding": __DbViewBase["twinAssetBinding"];
  /** @deprecated Use `twinComponent` instead. This alias will be removed in the next major version. */
  readonly "twin_component": __DbViewBase["twinComponent"];
  /** @deprecated Use `twinDofBinding` instead. This alias will be removed in the next major version. */
  readonly "twin_dof_binding": __DbViewBase["twinDofBinding"];
  /** @deprecated Use `twinDofLink` instead. This alias will be removed in the next major version. */
  readonly "twin_dof_link": __DbViewBase["twinDofLink"];
  /** @deprecated Use `twinGeometryBinding` instead. This alias will be removed in the next major version. */
  readonly "twin_geometry_binding": __DbViewBase["twinGeometryBinding"];
  /** @deprecated Use `twinPosition` instead. This alias will be removed in the next major version. */
  readonly "twin_position": __DbViewBase["twinPosition"];
  /** @deprecated Use `twinProperty` instead. This alias will be removed in the next major version. */
  readonly "twin_property": __DbViewBase["twinProperty"];
  /** @deprecated Use `twinRelationshipInstance` instead. This alias will be removed in the next major version. */
  readonly "twin_relationship_instance": __DbViewBase["twinRelationshipInstance"];
  /** @deprecated Use `twinTelemetryLink` instead. This alias will be removed in the next major version. */
  readonly "twin_telemetry_link": __DbViewBase["twinTelemetryLink"];
  /** @deprecated Use `twinUeClass` instead. This alias will be removed in the next major version. */
  readonly "twin_ue_class": __DbViewBase["twinUeClass"];
  /** @deprecated Use `ueProjectConfig` instead. This alias will be removed in the next major version. */
  readonly "ue_project_config": __DbViewBase["ueProjectConfig"];
  /** @deprecated Use `myProjectBackgroundLayerKeys` instead. This alias will be removed in the next major version. */
  readonly "my_project_background_layer_keys": __DbViewBase["myProjectBackgroundLayerKeys"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `complexProperty` instead. This alias will be removed in the next major version. */
  readonly "complex_property": __TablesBase["complexProperty"];
  /** @deprecated Use `digitalTwin` instead. This alias will be removed in the next major version. */
  readonly "digital_twin": __TablesBase["digitalTwin"];
  /** @deprecated Use `digitalTwinOrphaned` instead. This alias will be removed in the next major version. */
  readonly "digital_twin_orphaned": __TablesBase["digitalTwinOrphaned"];
  /** @deprecated Use `dtdlComponent` instead. This alias will be removed in the next major version. */
  readonly "dtdl_component": __TablesBase["dtdlComponent"];
  /** @deprecated Use `dtdlExtends` instead. This alias will be removed in the next major version. */
  readonly "dtdl_extends": __TablesBase["dtdlExtends"];
  /** @deprecated Use `dtdlInheritanceChain` instead. This alias will be removed in the next major version. */
  readonly "dtdl_inheritance_chain": __TablesBase["dtdlInheritanceChain"];
  /** @deprecated Use `dtdlInterface` instead. This alias will be removed in the next major version. */
  readonly "dtdl_interface": __TablesBase["dtdlInterface"];
  /** @deprecated Use `dtdlProperty` instead. This alias will be removed in the next major version. */
  readonly "dtdl_property": __TablesBase["dtdlProperty"];
  /** @deprecated Use `dtdlRelationship` instead. This alias will be removed in the next major version. */
  readonly "dtdl_relationship": __TablesBase["dtdlRelationship"];
  /** @deprecated Use `dtdlTelemetry` instead. This alias will be removed in the next major version. */
  readonly "dtdl_telemetry": __TablesBase["dtdlTelemetry"];
  /** @deprecated Use `editJournal` instead. This alias will be removed in the next major version. */
  readonly "edit_journal": __TablesBase["editJournal"];
  /** @deprecated Use `exportResultEvent` instead. This alias will be removed in the next major version. */
  readonly "export_result_event": __TablesBase["exportResultEvent"];
  /** @deprecated Use `importDryRunResultEvent` instead. This alias will be removed in the next major version. */
  readonly "import_dry_run_result_event": __TablesBase["importDryRunResultEvent"];
  /** @deprecated Use `importMappingProgressEvent` instead. This alias will be removed in the next major version. */
  readonly "import_mapping_progress_event": __TablesBase["importMappingProgressEvent"];
  /** @deprecated Use `importMappingRequestEvent` instead. This alias will be removed in the next major version. */
  readonly "import_mapping_request_event": __TablesBase["importMappingRequestEvent"];
  /** @deprecated Use `importMappingResultEvent` instead. This alias will be removed in the next major version. */
  readonly "import_mapping_result_event": __TablesBase["importMappingResultEvent"];
  /** @deprecated Use `importRun` instead. This alias will be removed in the next major version. */
  readonly "import_run": __TablesBase["importRun"];
  /** @deprecated Use `importTemplate` instead. This alias will be removed in the next major version. */
  readonly "import_template": __TablesBase["importTemplate"];
  /** @deprecated Use `importWarning` instead. This alias will be removed in the next major version. */
  readonly "import_warning": __TablesBase["importWarning"];
  /** @deprecated Use `modelAssetBinding` instead. This alias will be removed in the next major version. */
  readonly "model_asset_binding": __TablesBase["modelAssetBinding"];
  /** @deprecated Use `modelDofLink` instead. This alias will be removed in the next major version. */
  readonly "model_dof_link": __TablesBase["modelDofLink"];
  /** @deprecated Use `modelUeClass` instead. This alias will be removed in the next major version. */
  readonly "model_ue_class": __TablesBase["modelUeClass"];
  /** @deprecated Use `modelVersions` instead. This alias will be removed in the next major version. */
  readonly "model_versions": __TablesBase["modelVersions"];
  /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
  readonly "module_user": __TablesBase["moduleUser"];
  /** @deprecated Use `primitivePropertyBool` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_bool": __TablesBase["primitivePropertyBool"];
  /** @deprecated Use `primitivePropertyByte` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_byte": __TablesBase["primitivePropertyByte"];
  /** @deprecated Use `primitivePropertyBytes` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_bytes": __TablesBase["primitivePropertyBytes"];
  /** @deprecated Use `primitivePropertyDate` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_date": __TablesBase["primitivePropertyDate"];
  /** @deprecated Use `primitivePropertyDateTime` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_date_time": __TablesBase["primitivePropertyDateTime"];
  /** @deprecated Use `primitivePropertyDecimal` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_decimal": __TablesBase["primitivePropertyDecimal"];
  /** @deprecated Use `primitivePropertyDouble` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_double": __TablesBase["primitivePropertyDouble"];
  /** @deprecated Use `primitivePropertyDuration` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_duration": __TablesBase["primitivePropertyDuration"];
  /** @deprecated Use `primitivePropertyFloat` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_float": __TablesBase["primitivePropertyFloat"];
  /** @deprecated Use `primitivePropertyInteger` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_integer": __TablesBase["primitivePropertyInteger"];
  /** @deprecated Use `primitivePropertyLong` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_long": __TablesBase["primitivePropertyLong"];
  /** @deprecated Use `primitivePropertyShort` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_short": __TablesBase["primitivePropertyShort"];
  /** @deprecated Use `primitivePropertyString` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_string": __TablesBase["primitivePropertyString"];
  /** @deprecated Use `primitivePropertyTime` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_time": __TablesBase["primitivePropertyTime"];
  /** @deprecated Use `primitivePropertyUnsignedByte` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_unsigned_byte": __TablesBase["primitivePropertyUnsignedByte"];
  /** @deprecated Use `primitivePropertyUnsignedInteger` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_unsigned_integer": __TablesBase["primitivePropertyUnsignedInteger"];
  /** @deprecated Use `primitivePropertyUnsignedLong` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_unsigned_long": __TablesBase["primitivePropertyUnsignedLong"];
  /** @deprecated Use `primitivePropertyUnsignedShort` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_unsigned_short": __TablesBase["primitivePropertyUnsignedShort"];
  /** @deprecated Use `primitivePropertyUuid` instead. This alias will be removed in the next major version. */
  readonly "primitive_property_uuid": __TablesBase["primitivePropertyUuid"];
  /** @deprecated Use `projectBackgroundLayer` instead. This alias will be removed in the next major version. */
  readonly "project_background_layer": __TablesBase["projectBackgroundLayer"];
  /** @deprecated Use `projectConfig` instead. This alias will be removed in the next major version. */
  readonly "project_config": __TablesBase["projectConfig"];
  /** @deprecated Use `projectControlPoint` instead. This alias will be removed in the next major version. */
  readonly "project_control_point": __TablesBase["projectControlPoint"];
  /** @deprecated Use `projectSurface` instead. This alias will be removed in the next major version. */
  readonly "project_surface": __TablesBase["projectSurface"];
  /** @deprecated Use `projectSurfaceClientState` instead. This alias will be removed in the next major version. */
  readonly "project_surface_client_state": __TablesBase["projectSurfaceClientState"];
  /** @deprecated Use `relationshipCascadeRule` instead. This alias will be removed in the next major version. */
  readonly "relationship_cascade_rule": __TablesBase["relationshipCascadeRule"];
  /** @deprecated Use `systemConfig` instead. This alias will be removed in the next major version. */
  readonly "system_config": __TablesBase["systemConfig"];
  /** @deprecated Use `turbotwinMetadata` instead. This alias will be removed in the next major version. */
  readonly "turbotwin_metadata": __TablesBase["turbotwinMetadata"];
  /** @deprecated Use `twinAssetBinding` instead. This alias will be removed in the next major version. */
  readonly "twin_asset_binding": __TablesBase["twinAssetBinding"];
  /** @deprecated Use `twinComponent` instead. This alias will be removed in the next major version. */
  readonly "twin_component": __TablesBase["twinComponent"];
  /** @deprecated Use `twinDofBinding` instead. This alias will be removed in the next major version. */
  readonly "twin_dof_binding": __TablesBase["twinDofBinding"];
  /** @deprecated Use `twinDofLink` instead. This alias will be removed in the next major version. */
  readonly "twin_dof_link": __TablesBase["twinDofLink"];
  /** @deprecated Use `twinGeometryBinding` instead. This alias will be removed in the next major version. */
  readonly "twin_geometry_binding": __TablesBase["twinGeometryBinding"];
  /** @deprecated Use `twinPosition` instead. This alias will be removed in the next major version. */
  readonly "twin_position": __TablesBase["twinPosition"];
  /** @deprecated Use `twinProperty` instead. This alias will be removed in the next major version. */
  readonly "twin_property": __TablesBase["twinProperty"];
  /** @deprecated Use `twinRelationshipInstance` instead. This alias will be removed in the next major version. */
  readonly "twin_relationship_instance": __TablesBase["twinRelationshipInstance"];
  /** @deprecated Use `twinTelemetryLink` instead. This alias will be removed in the next major version. */
  readonly "twin_telemetry_link": __TablesBase["twinTelemetryLink"];
  /** @deprecated Use `twinUeClass` instead. This alias will be removed in the next major version. */
  readonly "twin_ue_class": __TablesBase["twinUeClass"];
  /** @deprecated Use `ueProjectConfig` instead. This alias will be removed in the next major version. */
  readonly "ue_project_config": __TablesBase["ueProjectConfig"];
  /** @deprecated Use `myProjectBackgroundLayerKeys` instead. This alias will be removed in the next major version. */
  readonly "my_project_background_layer_keys": __TablesBase["myProjectBackgroundLayerKeys"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

